import '../styles/PageGlobal.css';
import './BonDeComClientListPage.css';

import React, { useState, useEffect, useCallback } from "react";
import { useNavigate } from "react-router-dom";

import ReferenceButton from '../components/ReferenceButton';
import { BCCService } from '../services/BCCService.js';       
import { WorkFlowService } from '../services/WorkFlowService.js';

export default function BonDeComClientListPage() {
  const navigate = useNavigate();
  
  const [bccList, setBccList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [isSyncing, setIsSyncing] = useState(false);

  // Charger la liste des BCC
  const fetchBCC = useCallback(async () => {
    const service = new BCCService();
    setLoading(true);
    setError(null);
    try {
      const data = await service.getAllBCC();
      setBccList(data || []);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchBCC();
  }, [fetchBCC]);

  // : Synchroniser automatiquement tous les devis CLOSED
  const handleSyncClosedDevis = async () => {
    setIsSyncing(true);
    try {
      const workflowService = new WorkFlowService();
      const result = await workflowService.syncAllClosedDevis();
      
      // Rafraîchir la liste pour voir les nouveaux BCC
      await fetchBCC();
      
      // Afficher un message discret (optionnel)
      if (result && result !== "0 BCC créés automatiquement") {
        console.log(" Synchronisation :", result);
      }
    } catch (err) {
      console.error("Erreur synchronisation :", err.message);
    } finally {
      setIsSyncing(false);
    }
  };

  
  if (loading) return <div className="devis-status devis-status-loading">Chargement…</div>;
  if (error) return <div className="devis-status devis-status-error">{error}</div>;

  return (
    <div className="containerMain boncomclient-container">
      <h1 className="boncomclient-title">
        Liste des bons de commande clients
      </h1>

      <p className="boncomclient-protected">
        Générés automatiquement lors de la clôture d'un devis.
      </p>

      {/* TOP ACTIONS : LES DEUX BOUTONS */}
      <div style={{ display: 'flex', gap: '10px', marginBottom: '20px' }}>
        <ReferenceButton onClick={handleSyncClosedDevis} disabled={isSyncing}>
          {isSyncing ? 'Synchronisation...' : 'Synchroniser les devis clôturés'}
        </ReferenceButton>

       
      </div>

      {/* TABLE */}
      <div className="boncomclient-table-wrapper">
        <table className="boncomclient-table">
          <thead>
            <tr>
              <th>N</th>
              <th>Référence</th>
              <th>Devis Origine</th>
              <th>Client ID</th>
              <th>Statut</th>
              <th>Action</th>
            </tr>
          </thead>

          <tbody>
            {bccList.length === 0 ? (
              <tr>
                <td colSpan="6" style={{ textAlign: 'center', padding: '20px' }}>
                  Aucun bon de commande client.
                </td>
              </tr>
            ) : (
              bccList.map((bcc, index) => (
                <tr key={bcc.id}>
                  <td>{index + 1}</td>
                  <td>{bcc.reference || `BC-${bcc.id}`}</td>
                  <td>Devis #{bcc.devisId || 'N/A'}</td>
                  <td>{bcc.clientId || 'N/A'}</td>
                  <td>
                    <span className={`devis-statut-badge statut-${(bcc.status || 'DRAFT').toLowerCase()}`}>
                      {bcc.status || 'DRAFT'}
                    </span>
                  </td>
                  <td>
                    <button
                      className="boncomclient-btn boncomclient-btn-yellow"
                      onClick={() => navigate(`/bon_com_client_edit/${bcc.id}`)}
                    >
                      Details / Edit
                    </button>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}